module.exports = __webpack_public_path__ + "static/media/12UNCTAD20.c1648939.jpg";